/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `SegmentCondition*`'s.
 */
export type SegmentConditionType = SegmentConditionAnd | SegmentConditionOr;

/**
 * The segment condition `and` type.
 * @export
 */
export type SegmentConditionAnd = typeof SEGMENT_CONDITION_AND;

/**
 * The segment condition `or` type.
 * @export
 */
export type SegmentConditionOr = typeof SEGMENT_CONDITION_OR;

/**
 * The segment condition `and` constant.
 * @export
 */
export const SEGMENT_CONDITION_AND = `and`;

/**
 * The segment condition `or` constant.
 * @export
 */
export const SEGMENT_CONDITION_OR = `or`;
